import React from 'react';
import { HiBriefcase, HiCurrencyRupee, HiLocationMarker } from 'react-icons/hi';
import { Img } from 'react-image';
import { UIExtendedApplication } from 'types';
interface Props {
	application: UIExtendedApplication;
}
const PositionDetails = ({ application }: Props) => {
	const minSalary = application.position?.salary.min;
	const maxSalary = application.position?.salary.max;
	const location = application.position?.workLocations;
	const locationArray = Array.isArray(location) ? location : location ? [location] : [];
	const workLocation = application.position?.workLocation;
	if (workLocation && !locationArray.includes(workLocation)) {
		locationArray.push(workLocation);
	}
	const locationString = locationArray.join(' | ');
	console.log("locationString",locationString)
	const type = application.position?.positionType;
	const workingMode = application.position?.workingMode;
	const workingExp = application.position?.positionRequirement.workExperience
		? application.position?.positionRequirement.workExperience.min === 0 &&
		  application.position?.positionRequirement.workExperience.max === 0
			? 'Fresher'
			: `${Math.floor(application.position?.positionRequirement.workExperience.min)} Yrs ${
					Math.ceil(application.position?.positionRequirement.workExperience?.min * 12) % 12
			  } Mon - ${Math.floor(application.position?.positionRequirement.workExperience.max)} Yrs ${
					Math.ceil(application.position?.positionRequirement.workExperience?.max * 12) % 12
			  } Mon `
		: '';
	return (
		<div className="mt-[8px]">
			<div className="mt-2 flex flex-wrap gap-4">
				<div className="flex items-center text-sm font-medium dark:text-[#FAFAFC] text-black">
					<HiBriefcase className="text-[#00B7C4] dark:text-[#A9EFF2] w-[20px] h-[20px]" />
					<div className="ml-1 gap-1 flex">
						{workingMode === 'FullTime'
							? 'Full-Time'
							: workingMode === 'InternshipToFullTime'
							  ? 'Internship + Full-Time'
							  : workingMode}
						<Img className="ml-1 inline-block object-contain" src="/assets/dot.svg" alt="currency" width={6} height={6} />
						<span className="ml-1">{workingExp}</span>
					</div>
				</div>

				<div className="text-sm font-medium dark:text-[#FAFAFC] text-black">
					<span className="mr-1 inline-block align-middle">
						<HiCurrencyRupee className="text-[#00B7C4] dark:text-[#A9EFF2] w-[20px] h-[20px]" />
					</span>
					{minSalary} - {maxSalary} LPA
				</div>
				<div className="text-sm font-medium dark:text-[#FAFAFC] text-black">
					<span className="mr-1 inline-block align-middle">
						<HiLocationMarker className="text-[#00B7C4] dark:text-[#A9EFF2] w-[16px] h-[16px]" />
					</span>
					{locationString}
					<span className="mx-1 inline-block h-2 align-middle">
						<Img src="/assets/dot.svg" alt="dot" width={6} height={6} />
					</span>
					{type}
				</div>
			</div>
		</div>
	);
};

export default PositionDetails;
